import { SalesOrder } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 1264. プロジェクト（売上）継続無し更新
 * [PUT] /workspaces/:identifier/teams/:team_id/sales_orders/:id/update_not_renewed
 */
type Props = {
  identifier: string;
  team_id: number;
  id: number;
  not_renewed: boolean;
};

const updateSalesOrderNotRenewed = (props: Props): Promise<SalesOrder> => {
  return axios.put(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.id}/update_not_renewed`,
    props
  );
};

export const useUpdateSalesOrderNotRenewed = () => {
  return useMutation({
    mutationFn: updateSalesOrderNotRenewed,
  });
};
